import { DOCUMENT, EnvironmentInjector, afterNextRender, inject } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, Router } from '@angular/router';
import { filter, take } from 'rxjs';

// Keep in sync with the modulepreload hint in src/index.html
const WORKBENCH_SCRIPT = {
  src: 'https://assets.oneweb.mercedes-benz.com/plugin/workbench/core/7.30.0/workbench/workbench.esm.js',
  integrity: 'sha384-RHci5/Fd4pSCjeZXITihBPVdj7ACmSbWr/84GGOLgPvef4DjWFAYf8gxlhs2Zpjm',
};

/**
 * Loads the Workbench web components only after Angular has hydrated the server-rendered page.
 *
 * During hydration Angular re-applies static `class="..."` attributes via `setAttribute('class', ...)`.
 * If Workbench (Stencil) already upgraded the element, this wipes the classes it added, including
 * `hydrated`, and the component stays `visibility: hidden` forever (e.g. the desktop menu fly-in).
 * Route content hydrates after the initial (lazy) navigation, so we wait for it plus one render.
 *
 * Must be called in an injection context, in the browser only.
 */
export function loadWorkbenchAfterHydration(): void {
  const document = inject(DOCUMENT);
  const injector = inject(EnvironmentInjector);

  inject(Router)
    .events.pipe(
      filter((e) => e instanceof NavigationEnd || e instanceof NavigationCancel || e instanceof NavigationError),
      take(1)
    )
    .subscribe(() => {
      afterNextRender(
        () => {
          if (document.querySelector(`script[src="${WORKBENCH_SCRIPT.src}"]`)) return;

          const script = document.createElement('script');
          script.type = 'module';
          script.src = WORKBENCH_SCRIPT.src;
          script.integrity = WORKBENCH_SCRIPT.integrity;
          script.crossOrigin = 'anonymous';
          document.head.appendChild(script);
        },
        { injector }
      );
    });
}
